export const translations = {
  en: {
    brand: "Aadisarvtra",
    brandSub: "Multiservices Pvt. Ltd.",
    brandFull: "Aadisarvtra Multiservices Private Limited",
    nav: {
      services: "Services",
      products: "Products",
      about: "About Us",
      contact: "Contact",
      enquire: "Enquire Now",
      careers: "Careers",
      exam: "Online Exam",
      account: "My Account",
    },
    hero: {
      badge: "A Multi-Service Indian Enterprise",
      title: "One Company.",
      titleHighlight: "Every Service You Need.",
      subtitle:
        "From online restaurant, coaching and book publishing to construction, manpower supply, fire safety, trading and e-commerce — Aadisarvtra delivers trust across every sector.",
      explore: "Explore Services",
      enquire: "Enquire Now",
      stats: [
        { value: "10+", label: "Service Domains" },
        { value: "2", label: "Corporate Offices" },
        { value: "100%", label: "Quality Commitment" },
      ],
    },
    services: {
      heading: "Our Services",
      subheading:
        "A complete ecosystem of digital, engineering and commerce services — all under one trusted roof.",
      details: "View Details",
      enquire: "Enquire",
      featuresLabel: "What we offer",
      close: "Close",
    },
    serviceItems: {
      "online-restaurant": {
        title: "Online Restaurant & Cloud Kitchen",
        desc: "Authentic regional culinary delights delivered hot & fresh to your doorstep.",
        long: "Our cloud kitchen brings the taste of Purvanchal to your home. Order online from a curated menu of North Indian and regional dishes, prepared in hygienic kitchens and delivered quickly.",
        features: [
          "Online ordering with fast doorstep delivery",
          "Hygienic, quality-standard cloud kitchen",
          "North Indian & Purvanchali cuisine",
          "Bulk orders for events & offices",
        ],
      },
      "online-coaching": {
        title: "Online Coaching & EdTech",
        desc: "Interactive live classes, expert mentors and competitive exam preparation.",
        long: "Quality education for every student — live interactive classes, recorded lectures, doubt sessions and test series for school, board and competitive exams.",
        features: [
          "Live interactive online classes",
          "Competitive exam preparation",
          "Doubt-clearing & mentorship",
          "Affordable fee structure",
        ],
      },
      "book-publishing": {
        title: "Online Book Writing & Publishing",
        desc: "End-to-end editorial, ghostwriting, ISBN registration and distribution.",
        long: "From manuscript to marketplace — we help authors write, edit, design, publish and distribute books in print and digital formats across India.",
        features: [
          "Ghostwriting & editorial support",
          "ISBN registration & copyright",
          "Print & eBook publishing",
          "Online distribution & marketing",
        ],
      },
      "tours-travels": {
        title: "Online Tour & Travels",
        desc: "Tailored pilgrimage circuits, cab bookings and custom holiday packages.",
        long: "Explore India with us — pilgrimage tours (Kashi, Prayagraj, Ayodhya, Vindhyachal), custom holiday packages, hotel bookings and reliable cab services at honest prices.",
        features: [
          "Pilgrimage & tirth yatra packages",
          "Custom family holiday tours",
          "Cab & tempo traveller booking",
          "Hotel & stay arrangements",
        ],
      },
      "contract-construction": {
        title: "Contract & Construction (Civil, Electrical, Plumbing)",
        desc: "Turnkey civil construction, electrical installations and plumbing solutions.",
        long: "Government and private contract work — civil construction, building renovation, certified electrical wiring & fittings, and complete plumbing for residential and commercial projects.",
        features: [
          "Civil construction & renovation contracts",
          "Electrical wiring & installations",
          "Plumbing & sanitary works",
          "On-time project delivery",
        ],
      },
      "manpower-supply": {
        title: "Manpower Supply Services",
        desc: "Skilled, semi-skilled and technical workforce for industries.",
        long: "Reliable workforce solutions — we supply verified skilled, semi-skilled and unskilled manpower for factories, construction sites, offices, events and facility management.",
        features: [
          "Skilled & semi-skilled workforce",
          "Verified & trained personnel",
          "Factory, site & office staffing",
          "Flexible contract durations",
        ],
      },
      "fire-fighting": {
        title: "Fire Fighting & Safety Services",
        desc: "Fire hydrants, sprinkler systems, extinguishers and safety audits.",
        long: "Complete fire safety for buildings and industries — installation and maintenance of fire hydrants, sprinkler & alarm systems, extinguisher supply/refilling and safety compliance audits.",
        features: [
          "Fire hydrant & sprinkler installation",
          "Extinguisher supply & refilling",
          "Fire alarm & detection systems",
          "Safety audits & NOC support",
        ],
      },
      "trading-wholesale-retail": {
        title: "Trading (Wholesale & Retail)",
        desc: "B2B bulk supply chain and direct consumer retail distribution.",
        long: "A dependable trading network — wholesale supply of FMCG, food grains, electrical goods, construction material and safety equipment to retailers and institutions, plus direct retail sales.",
        features: [
          "FMCG & food grain wholesale",
          "Electrical & construction material supply",
          "Institutional & retail distribution",
          "Competitive bulk pricing",
        ],
      },
      ecommerce: {
        title: "E-Commerce Solutions",
        desc: "Quality products online with swift doorstep delivery.",
        long: "Shop from our online marketplace — curated quality products across categories with transparent pricing, easy ordering and fast delivery to your doorstep.",
        features: [
          "Curated quality product catalogue",
          "Easy online ordering",
          "Fast doorstep delivery",
          "Secure & transparent pricing",
        ],
      },
    },
    products: {
      heading: "Products & Trading",
      subheading:
        "Quality wholesale & retail products from our trading and e-commerce verticals.",
      enquire: "Enquire",
      buyNow: "Buy Now",
      razorpay: "Razorpay (UPI/Card)",
    },
    productItems: {
      "packaged-foods": {
        name: "Packaged Foods & Snacks",
        desc: "Regional snacks and ready-to-eat items from our kitchen vertical.",
        price: "₹99 onwards",
      },
      "books-stationery": {
        name: "Books & Stationery",
        desc: "Published titles, notebooks and complete school supplies.",
        price: "₹49 onwards",
      },
      "electrical-goods": {
        name: "Electrical Goods",
        desc: "Wires, switches, LED lighting and certified fittings.",
        price: "₹199 onwards",
      },
      "safety-equipment": {
        name: "Fire & Safety Equipment",
        desc: "Extinguishers, alarms and industrial safety gear.",
        price: "₹499 onwards",
      },
      "construction-material": {
        name: "Construction Material",
        desc: "Cement, TMT steel, sanitary and plumbing material in bulk.",
        price: "Bulk rates",
      },
      "household-essentials": {
        name: "Household Essentials",
        desc: "Daily-use FMCG products at genuine wholesale prices.",
        price: "Wholesale prices",
      },
    },
    about: {
      heading: "About Aadisarvtra",
      subheading: "A diversified enterprise rooted in Uttar Pradesh, serving all of India.",
      para1:
        "Aadisarvtra Multiservices Private Limited is a diversified Indian enterprise spanning hospitality, education, publishing, tourism, engineering contracts, manpower, fire safety, trading and e-commerce.",
      para2:
        "With our head office in Prayagraj and a branch office in Mirzapur, we combine local trust with professional standards — one accountable partner for every need of your home, business or institution.",
      headOffice: "Head Office — Prayagraj",
      branchOffice: "Branch Office — Mirzapur",
      headAddress: "126/57 Abubakarpur, Preetam-Nagar, Prayagraj - 211011, Uttar Pradesh",
      branchAddress: "Premapur, Ramgarh (Kriyat), Mirzapur - 231306, Uttar Pradesh",
      trust: [
        "Registered Private Limited Company",
        "Pan-India Service Network",
        "Customer-First Commitment",
      ],
    },
    enquiry: {
      heading: "Send an Enquiry",
      subheading: "Tell us what you need — our team will reach out within 24 hours.",
      contactInfo: "Contact Information",
      name: "Full Name",
      namePlaceholder: "Enter your name",
      phone: "Phone Number",
      phonePlaceholder: "Enter your phone number",
      email: "Email (optional)",
      service: "Select Service",
      message: "Your Message",
      messagePlaceholder: "Describe your requirement...",
      submit: "Submit Enquiry",
      whatsapp: "Send on WhatsApp",
      success: "Enquiry submitted! We will contact you soon.",
      error: "Something went wrong. Please try again.",
      other: "Other",
    },
    footer: {
      tagline: "Empowering tomorrow across services, engineering & commerce.",
      quickLinks: "Quick Links",
      offices: "Our Offices",
      rights: "All rights reserved.",
      adminLogin: "Admin Login",
    },
    careers: {
      badge: "Join Our Team",
      heading: "Careers at Aadisarvtra",
      subheading: "Build your career with a growing multi-service enterprise across Uttar Pradesh.",
      openings: "Openings",
      apply: "Apply Now",
      noJobs: "No open positions right now — please check back soon.",
      applyFor: "Apply for",
      resume: "Resume (PDF/DOC/DOCX, max 5MB)",
      coverNote: "Cover Note (optional)",
      submit: "Submit Application",
      success: "Application submitted! Our HR team will contact you.",
      error: "Submission failed. Please try again.",
      chooseFile: "Choose file",
    },
    emp: {
      portal: "Employee Portal",
      welcome: "Welcome",
      today: "Today's Attendance",
      checkIn: "Check In",
      checkOut: "Check Out",
      checkedInAt: "Checked in at",
      checkedOutAt: "Checked out at",
      notCheckedIn: "You have not checked in yet today.",
      done: "Attendance completed for today.",
      myAttendance: "My Attendance",
      myPayslips: "My Payslips",
      date: "Date",
      hours: "Hours",
      overtime: "Overtime (hrs)",
      month: "Month",
      gross: "Gross",
      netPay: "Net Pay",
      download: "Payslip",
      noRecords: "No records yet.",
      status: "Status",
    },
    exam: {
      badge: "Online Examination",
      heading: "Online Tests & Certification",
      subheading: "Attempt online exams and earn a certificate from Aadisarvtra.",
      questions: "Questions",
      minutes: "minutes",
      passing: "Passing",
      start: "Start Test",
      noExams: "No active exams right now — please check back soon.",
      candidateInfo: "Enter your details to begin",
      begin: "Begin Test",
      timeLeft: "Time left",
      submit: "Submit Answers",
      result: "Your Result",
      score: "Score",
      congrats: "Congratulations! You passed.",
      failed: "You did not pass this time. Try again!",
      downloadCert: "Download Certificate",
      backToExams: "Back to Exams",
    },
    payment: {
      checking: "Confirming your payment...",
      successTitle: "Payment Successful!",
      successMsg: "Thank you! Your order has been received. Our team will contact you shortly.",
      failed: "Payment could not be verified or was cancelled.",
      backHome: "Back to Home",
    },
    upi: {
      payViaUpi: "Pay via UPI",
      scanQr: "Scan this QR with any UPI app (GPay, PhonePe, Paytm)",
      upiId: "UPI ID",
      copy: "Copy",
      copied: "UPI ID copied!",
      amount: "Amount",
      note: "After payment, share the screenshot on WhatsApp for order confirmation.",
    },
    account: {
      login: "Login",
      register: "Create Account",
      loginSubtitle: "Access your orders and exam results",
      name: "Full Name",
      email: "Email",
      password: "Password",
      myAccount: "My Account",
      myOrders: "My Orders",
      myResults: "My Exam Results",
      noOrders: "No orders yet. Orders placed while logged in will appear here.",
      noResults: "No exam attempts found for your email.",
      date: "Date",
      product: "Product",
      amount: "Amount",
      status: "Status",
      exam: "Exam",
      score: "Score",
      certificate: "Certificate",
      logout: "Logout",
      welcome: "Welcome",
      pass: "PASS",
      fail: "FAIL",
    },
    admin: {
      login: "Admin Login",
      loginSubtitle: "Sign in to manage enquiries",
      email: "Email",
      password: "Password",
      signIn: "Sign In",
      or: "or",
      googleSignIn: "Sign in with Google",
      forgot: "Forgot password?",
      backHome: "Back to Website",
      dashboard: "Enquiry Dashboard",
      secEnquiries: "Enquiries",
      secCareers: "Careers",
      secEmployees: "Employees",
      secAttendance: "Attendance",
      secPayroll: "Payroll",
      secInvoices: "Invoices",
      secQuotations: "Quotations",
      secExams: "Exams",
      logout: "Logout",
      total: "Total Enquiries",
      pending: "Pending",
      inProgress: "In Progress",
      closed: "Closed",
      search: "Search name or phone...",
      allStatuses: "All Statuses",
      allServices: "All Services",
      exportCsv: "Export CSV",
      date: "Date",
      name: "Name",
      phone: "Phone",
      service: "Service",
      message: "Message",
      status: "Status",
      actions: "Actions",
      noEnquiries: "No enquiries found.",
      loading: "Loading...",
      statusUpdated: "Status updated",
      deleted: "Enquiry deleted",
      forgotTitle: "Forgot Password",
      forgotSubtitle: "Enter your admin email to receive a reset link.",
      sendLink: "Send Reset Link",
      linkSent: "If that email is registered, a reset link has been sent.",
      resetTitle: "Reset Password",
      newPassword: "New Password",
      resetButton: "Reset Password",
      resetSuccess: "Password reset successful. You can now sign in.",
      backToLogin: "Back to sign in",
    },
  },
  hi: {
    brand: "आदिसर्वत्र",
    brandSub: "मल्टीसर्विसेज प्रा. लि.",
    brandFull: "आदिसर्वत्र मल्टीसर्विसेज प्राइवेट लिमिटेड",
    nav: {
      services: "सेवाएं",
      products: "उत्पाद",
      about: "हमारे बारे में",
      contact: "संपर्क करें",
      enquire: "पूछताछ करें",
      careers: "करियर",
      exam: "ऑनलाइन परीक्षा",
      account: "मेरा खाता",
    },
    hero: {
      badge: "एक बहु-सेवा भारतीय उद्यम",
      title: "एक कंपनी।",
      titleHighlight: "आपकी हर सेवा।",
      subtitle:
        "ऑनलाइन रेस्टोरेंट, कोचिंग एवं पुस्तक प्रकाशन से लेकर निर्माण, मैनपावर, फायर सेफ्टी, ट्रेडिंग एवं ई-कॉमर्स तक — आदिसर्वत्र हर क्षेत्र में भरोसा देता है।",
      explore: "सेवाएं देखें",
      enquire: "पूछताछ करें",
      stats: [
        { value: "10+", label: "सेवा क्षेत्र" },
        { value: "2", label: "कार्यालय" },
        { value: "100%", label: "गुणवत्ता वचन" },
      ],
    },
    services: {
      heading: "हमारी सेवाएं",
      subheading: "डिजिटल, इंजीनियरिंग एवं कॉमर्स सेवाओं का संपूर्ण समाधान — एक भरोसेमंद छत के नीचे।",
      details: "विवरण देखें",
      enquire: "पूछताछ",
      featuresLabel: "हम क्या प्रदान करते हैं",
      close: "बंद करें",
    },
    serviceItems: {
      "online-restaurant": {
        title: "ऑनलाइन रेस्टोरेंट एवं क्लाउड किचन",
        desc: "स्वादिष्ट एवं प्रामाणिक क्षेत्रीय व्यंजन, गरम और ताज़ा — सीधे आपके द्वार।",
        long: "हमारा क्लाउड किचन पूर्वांचल का स्वाद आपके घर तक पहुँचाता है। स्वच्छ रसोई में बने उत्तर भारतीय एवं क्षेत्रीय व्यंजनों का ऑनलाइन ऑर्डर करें और त्वरित डिलीवरी पाएं।",
        features: [
          "तेज़ होम डिलीवरी के साथ ऑनलाइन ऑर्डर",
          "स्वच्छता मानकों वाला क्लाउड किचन",
          "उत्तर भारतीय एवं पूर्वांचली व्यंजन",
          "इवेंट एवं ऑफिस के लिए बल्क ऑर्डर",
        ],
      },
      "online-coaching": {
        title: "ऑनलाइन कोचिंग एवं शिक्षा",
        desc: "लाइव कक्षाएं, विशेषज्ञ मार्गदर्शन एवं प्रतियोगी परीक्षाओं की तैयारी।",
        long: "हर विद्यार्थी के लिए गुणवत्तापूर्ण शिक्षा — स्कूल, बोर्ड एवं प्रतियोगी परीक्षाओं हेतु लाइव कक्षाएं, रिकॉर्डेड लेक्चर, डाउट सेशन एवं टेस्ट सीरीज़।",
        features: [
          "लाइव इंटरैक्टिव ऑनलाइन कक्षाएं",
          "प्रतियोगी परीक्षाओं की तैयारी",
          "डाउट समाधान एवं मेंटरशिप",
          "किफायती फीस संरचना",
        ],
      },
      "book-publishing": {
        title: "ऑनलाइन पुस्तक लेखन एवं प्रकाशन",
        desc: "लेखन सहायता, आईएसबीएन पंजीकरण एवं पुस्तक प्रकाशन।",
        long: "पांडुलिपि से बाज़ार तक — हम लेखकों को पुस्तक लेखन, संपादन, डिज़ाइन, प्रकाशन एवं वितरण में संपूर्ण सहायता प्रदान करते हैं।",
        features: [
          "घोस्टराइटिंग एवं संपादन सहायता",
          "आईएसबीएन पंजीकरण एवं कॉपीराइट",
          "प्रिंट एवं ई-बुक प्रकाशन",
          "ऑनलाइन वितरण एवं मार्केटिंग",
        ],
      },
      "tours-travels": {
        title: "ऑनलाइन टूर एवं ट्रैवल्स",
        desc: "तीर्थयात्रा पैकेज, टैक्सी बुकिंग एवं कस्टम टूर पैकेज।",
        long: "हमारे साथ भारत घूमिए — तीर्थयात्रा (काशी, प्रयागराज, अयोध्या, विंध्याचल), कस्टम हॉलिडे पैकेज, होटल बुकिंग एवं विश्वसनीय कैब सेवाएं, सही दाम पर।",
        features: [
          "तीर्थयात्रा टूर पैकेज",
          "कस्टम फैमिली हॉलिडे टूर",
          "कैब एवं टेम्पो ट्रैवलर बुकिंग",
          "होटल एवं ठहरने की व्यवस्था",
        ],
      },
      "contract-construction": {
        title: "अनुबंध एवं निर्माण (सिविल, इलेक्ट्रिकल, प्लंबिंग)",
        desc: "सिविल निर्माण, इलेक्ट्रिकल फिटिंग एवं प्लंबिंग समाधान।",
        long: "सरकारी एवं निजी ठेका कार्य — सिविल निर्माण, भवन मरम्मत, प्रमाणित इलेक्ट्रिकल वायरिंग एवं आवासीय/वाणिज्यिक परियोजनाओं के लिए संपूर्ण प्लंबिंग।",
        features: [
          "सिविल निर्माण एवं मरम्मत ठेके",
          "इलेक्ट्रिकल वायरिंग एवं इंस्टॉलेशन",
          "प्लंबिंग एवं सेनेटरी कार्य",
          "समय पर परियोजना पूर्णता",
        ],
      },
      "manpower-supply": {
        title: "मैनपावर सप्लाई सर्विसेज",
        desc: "उद्योगों के लिए कुशल एवं प्रशिक्षित जनशक्ति आपूर्ति।",
        long: "विश्वसनीय जनशक्ति समाधान — फैक्ट्री, निर्माण साइट, ऑफिस, इवेंट एवं फैसिलिटी मैनेजमेंट हेतु सत्यापित कुशल, अर्ध-कुशल एवं अकुशल जनशक्ति उपलब्ध कराते हैं।",
        features: [
          "कुशल एवं अर्ध-कुशल जनशक्ति",
          "सत्यापित एवं प्रशिक्षित कर्मी",
          "फैक्ट्री, साइट एवं ऑफिस स्टाफिंग",
          "लचीली अनुबंध अवधि",
        ],
      },
      "fire-fighting": {
        title: "फायर फाइटिंग एवं सुरक्षा सेवाएं",
        desc: "फायर हाइड्रेंट, स्प्रिंकलर सिस्टम, एक्सटिंग्विशर एवं सुरक्षा ऑडिट।",
        long: "भवनों एवं उद्योगों के लिए संपूर्ण अग्नि सुरक्षा — फायर हाइड्रेंट, स्प्रिंकलर एवं अलार्म सिस्टम की स्थापना/रखरखाव, एक्सटिंग्विशर आपूर्ति/रिफिलिंग एवं सेफ्टी ऑडिट।",
        features: [
          "फायर हाइड्रेंट एवं स्प्रिंकलर इंस्टॉलेशन",
          "एक्सटिंग्विशर आपूर्ति एवं रिफिलिंग",
          "फायर अलार्म एवं डिटेक्शन सिस्टम",
          "सेफ्टी ऑडिट एवं एनओसी सहायता",
        ],
      },
      "trading-wholesale-retail": {
        title: "ट्रेडिंग (थोक एवं खुदरा)",
        desc: "बी2बी थोक आपूर्ति एवं खुदरा वितरण नेटवर्क।",
        long: "भरोसेमंद ट्रेडिंग नेटवर्क — एफएमसीजी, खाद्यान्न, इलेक्ट्रिकल सामग्री, निर्माण सामग्री एवं सेफ्टी उपकरणों की थोक आपूर्ति तथा सीधी खुदरा बिक्री।",
        features: [
          "एफएमसीजी एवं खाद्यान्न थोक",
          "इलेक्ट्रिकल एवं निर्माण सामग्री",
          "संस्थागत एवं खुदरा वितरण",
          "प्रतिस्पर्धी बल्क मूल्य",
        ],
      },
      ecommerce: {
        title: "ई-कॉमर्स समाधान",
        desc: "गुणवत्तापूर्ण उत्पाद ऑनलाइन — तेज़ डोरस्टेप डिलीवरी।",
        long: "हमारे ऑनलाइन मार्केटप्लेस से खरीदारी करें — पारदर्शी मूल्य, आसान ऑर्डरिंग एवं तेज़ डिलीवरी के साथ चुनिंदा गुणवत्तापूर्ण उत्पाद।",
        features: [
          "चुनिंदा गुणवत्तापूर्ण उत्पाद सूची",
          "आसान ऑनलाइन ऑर्डरिंग",
          "तेज़ डोरस्टेप डिलीवरी",
          "सुरक्षित एवं पारदर्शी मूल्य",
        ],
      },
    },
    products: {
      heading: "उत्पाद एवं ट्रेडिंग",
      subheading: "हमारे ट्रेडिंग एवं ई-कॉमर्स विभागों के गुणवत्तापूर्ण थोक एवं खुदरा उत्पाद।",
      enquire: "पूछताछ",
      buyNow: "अभी खरीदें",
      razorpay: "Razorpay (UPI/कार्ड)",
    },
    productItems: {
      "packaged-foods": {
        name: "पैकेज्ड फूड एवं स्नैक्स",
        desc: "हमारे किचन विभाग के क्षेत्रीय स्नैक्स एवं रेडी-टू-ईट आइटम।",
        price: "₹99 से शुरू",
      },
      "books-stationery": {
        name: "पुस्तकें एवं स्टेशनरी",
        desc: "प्रकाशित पुस्तकें, कॉपियां एवं संपूर्ण स्कूल सामग्री।",
        price: "₹49 से शुरू",
      },
      "electrical-goods": {
        name: "इलेक्ट्रिकल सामग्री",
        desc: "तार, स्विच, एलईडी लाइटिंग एवं प्रमाणित फिटिंग।",
        price: "₹199 से शुरू",
      },
      "safety-equipment": {
        name: "फायर एवं सेफ्टी उपकरण",
        desc: "एक्सटिंग्विशर, अलार्म एवं औद्योगिक सुरक्षा उपकरण।",
        price: "₹499 से शुरू",
      },
      "construction-material": {
        name: "निर्माण सामग्री",
        desc: "सीमेंट, टीएमटी सरिया, सेनेटरी एवं प्लंबिंग सामग्री थोक में।",
        price: "थोक दरें",
      },
      "household-essentials": {
        name: "घरेलू आवश्यक वस्तुएं",
        desc: "दैनिक उपयोग के एफएमसीजी उत्पाद, सही थोक मूल्य पर।",
        price: "थोक मूल्य",
      },
    },
    about: {
      heading: "आदिसर्वत्र के बारे में",
      subheading: "उत्तर प्रदेश में जड़ें, पूरे भारत में सेवा।",
      para1:
        "आदिसर्वत्र मल्टीसर्विसेज प्राइवेट लिमिटेड एक विविध भारतीय उद्यम है — हॉस्पिटैलिटी, शिक्षा, प्रकाशन, पर्यटन, इंजीनियरिंग ठेके, मैनपावर, फायर सेफ्टी, ट्रेडिंग एवं ई-कॉमर्स।",
      para2:
        "प्रयागराज के प्रधान कार्यालय एवं मिर्जापुर के शाखा कार्यालय के साथ, हम स्थानीय भरोसे को व्यावसायिक मानकों से जोड़ते हैं — आपके घर, व्यापार एवं संस्था की हर ज़रूरत के लिए एक जिम्मेदार साथी।",
      headOffice: "प्रधान कार्यालय — प्रयागराज",
      branchOffice: "शाखा कार्यालय — मिर्जापुर",
      headAddress: "126/57 अबुबकरपुर, प्रीतम नगर, प्रयागराज - 211011, उत्तर प्रदेश",
      branchAddress: "प्रेमापुर, रामगढ़ (क्रियात), मिर्जापुर - 231306, उत्तर प्रदेश",
      trust: [
        "पंजीकृत प्राइवेट लिमिटेड कंपनी",
        "अखिल भारतीय सेवा नेटवर्क",
        "ग्राहक-प्रथम प्रतिबद्धता",
      ],
    },
    enquiry: {
      heading: "पूछताछ भेजें",
      subheading: "बताइए आपको क्या चाहिए — हमारी टीम 24 घंटे के भीतर संपर्क करेगी।",
      contactInfo: "संपर्क जानकारी",
      name: "पूरा नाम",
      namePlaceholder: "अपना नाम लिखें",
      phone: "फोन नंबर",
      phonePlaceholder: "अपना फोन नंबर लिखें",
      email: "ईमेल (वैकल्पिक)",
      service: "सेवा चुनें",
      message: "आपका संदेश",
      messagePlaceholder: "अपनी ज़रूरत लिखें...",
      submit: "पूछताछ भेजें",
      whatsapp: "WhatsApp पर भेजें",
      success: "पूछताछ भेज दी गई! हम जल्द ही संपर्क करेंगे।",
      error: "कुछ गलत हुआ। कृपया पुनः प्रयास करें।",
      other: "अन्य",
    },
    footer: {
      tagline: "सेवाओं, इंजीनियरिंग एवं व्यापार में सशक्त कल का निर्माण।",
      quickLinks: "त्वरित लिंक",
      offices: "हमारे कार्यालय",
      rights: "सर्वाधिकार सुरक्षित।",
      adminLogin: "एडमिन लॉगिन",
    },
    careers: {
      badge: "हमारी टीम से जुड़ें",
      heading: "आदिसर्वत्र में करियर",
      subheading: "उत्तर प्रदेश के बढ़ते बहु-सेवा उद्यम के साथ अपना करियर बनाएं।",
      openings: "रिक्तियां",
      apply: "आवेदन करें",
      noJobs: "अभी कोई रिक्ति नहीं है — कृपया बाद में देखें।",
      applyFor: "पद हेतु आवेदन",
      resume: "रिज़्यूमे (PDF/DOC/DOCX, अधिकतम 5MB)",
      coverNote: "कवर नोट (वैकल्पिक)",
      submit: "आवेदन भेजें",
      success: "आवेदन भेज दिया गया! हमारी HR टीम संपर्क करेगी।",
      error: "सबमिट नहीं हो पाया। पुनः प्रयास करें।",
      chooseFile: "फ़ाइल चुनें",
    },
    emp: {
      portal: "कर्मचारी पोर्टल",
      welcome: "स्वागत है",
      today: "आज की उपस्थिति",
      checkIn: "चेक इन",
      checkOut: "चेक आउट",
      checkedInAt: "चेक इन समय",
      checkedOutAt: "चेक आउट समय",
      notCheckedIn: "आपने आज अभी चेक इन नहीं किया।",
      done: "आज की उपस्थिति पूर्ण हो गई।",
      myAttendance: "मेरी उपस्थिति",
      myPayslips: "मेरी सैलरी स्लिप",
      date: "तिथि",
      hours: "घंटे",
      overtime: "ओवरटाइम (घंटे)",
      month: "माह",
      gross: "कुल",
      netPay: "नेट वेतन",
      download: "सैलरी स्लिप",
      noRecords: "अभी कोई रिकॉर्ड नहीं।",
      status: "स्थिति",
    },
    exam: {
      badge: "ऑनलाइन परीक्षा",
      heading: "ऑनलाइन टेस्ट एवं प्रमाणपत्र",
      subheading: "ऑनलाइन परीक्षा दें और आदिसर्वत्र का प्रमाणपत्र प्राप्त करें।",
      questions: "प्रश्न",
      minutes: "मिनट",
      passing: "उत्तीर्ण अंक",
      start: "टेस्ट शुरू करें",
      noExams: "अभी कोई परीक्षा सक्रिय नहीं है — कृपया बाद में देखें।",
      candidateInfo: "शुरू करने के लिए अपनी जानकारी भरें",
      begin: "टेस्ट शुरू करें",
      timeLeft: "शेष समय",
      submit: "उत्तर जमा करें",
      result: "आपका परिणाम",
      score: "अंक",
      congrats: "बधाई हो! आप उत्तीर्ण हुए।",
      failed: "इस बार उत्तीर्ण नहीं हुए। पुनः प्रयास करें!",
      downloadCert: "प्रमाणपत्र डाउनलोड करें",
      backToExams: "परीक्षाओं पर वापस",
    },
    payment: {
      checking: "आपके भुगतान की पुष्टि हो रही है...",
      successTitle: "भुगतान सफल!",
      successMsg: "धन्यवाद! आपका ऑर्डर मिल गया है। हमारी टीम शीघ्र ही संपर्क करेगी।",
      failed: "भुगतान सत्यापित नहीं हो सका या रद्द कर दिया गया।",
      backHome: "होम पर वापस",
    },
    upi: {
      payViaUpi: "UPI से भुगतान करें",
      scanQr: "किसी भी UPI ऐप (GPay, PhonePe, Paytm) से यह QR स्कैन करें",
      upiId: "UPI ID",
      copy: "कॉपी करें",
      copied: "UPI ID कॉपी हो गई!",
      amount: "राशि",
      note: "भुगतान के बाद ऑर्डर कन्फर्मेशन के लिए WhatsApp पर स्क्रीनशॉट भेजें।",
    },
    account: {
      login: "लॉगिन",
      register: "खाता बनाएं",
      loginSubtitle: "अपने ऑर्डर और परीक्षा परिणाम देखें",
      name: "पूरा नाम",
      email: "ईमेल",
      password: "पासवर्ड",
      myAccount: "मेरा खाता",
      myOrders: "मेरे ऑर्डर",
      myResults: "मेरे परीक्षा परिणाम",
      noOrders: "अभी कोई ऑर्डर नहीं। लॉगिन करके किए गए ऑर्डर यहाँ दिखेंगे।",
      noResults: "आपके ईमेल से कोई परीक्षा प्रयास नहीं मिला।",
      date: "तिथि",
      product: "उत्पाद",
      amount: "राशि",
      status: "स्थिति",
      exam: "परीक्षा",
      score: "अंक",
      certificate: "प्रमाणपत्र",
      logout: "लॉगआउट",
      welcome: "स्वागत है",
      pass: "उत्तीर्ण",
      fail: "अनुत्तीर्ण",
    },
    admin: {
      login: "एडमिन लॉगिन",
      loginSubtitle: "पूछताछ प्रबंधन के लिए साइन इन करें",
      email: "ईमेल",
      password: "पासवर्ड",
      signIn: "साइन इन",
      or: "या",
      googleSignIn: "Google से साइन इन करें",
      forgot: "पासवर्ड भूल गए?",
      backHome: "वेबसाइट पर वापस",
      dashboard: "पूछताछ डैशबोर्ड",
      secEnquiries: "पूछताछ",
      secCareers: "करियर",
      secEmployees: "कर्मचारी",
      secAttendance: "उपस्थिति",
      secPayroll: "पेरोल",
      secInvoices: "इनवॉइस",
      secQuotations: "कोटेशन",
      secExams: "परीक्षाएं",
      logout: "लॉगआउट",
      total: "कुल पूछताछ",
      pending: "लंबित",
      inProgress: "प्रगति में",
      closed: "बंद",
      search: "नाम या फोन खोजें...",
      allStatuses: "सभी स्थितियां",
      allServices: "सभी सेवाएं",
      exportCsv: "CSV निर्यात",
      date: "तिथि",
      name: "नाम",
      phone: "फोन",
      service: "सेवा",
      message: "संदेश",
      status: "स्थिति",
      actions: "कार्रवाई",
      noEnquiries: "कोई पूछताछ नहीं मिली।",
      loading: "लोड हो रहा है...",
      statusUpdated: "स्थिति अपडेट हुई",
      deleted: "पूछताछ हटाई गई",
      forgotTitle: "पासवर्ड भूल गए",
      forgotSubtitle: "रीसेट लिंक पाने के लिए अपना एडमिन ईमेल डालें।",
      sendLink: "रीसेट लिंक भेजें",
      linkSent: "यदि ईमेल पंजीकृत है, तो रीसेट लिंक भेज दिया गया है।",
      resetTitle: "पासवर्ड रीसेट करें",
      newPassword: "नया पासवर्ड",
      resetButton: "पासवर्ड रीसेट करें",
      resetSuccess: "पासवर्ड रीसेट सफल। अब आप साइन इन कर सकते हैं।",
      backToLogin: "साइन इन पर वापस",
    },
  },
};
